export default __webpack_public_path__ + "static/studycafe-office1-482dba17b0c5cbd9f6ccc338a168229b.jpg";